import { ContextLink, EventTypeLink, MachinesScreen, MetricTypeLink, NowSubScreen } from '@v2/pages/machines/common/enums';
import { BatchDocuments, BatchGeneral, BatchTimelineScreen } from '@v2/pages/machines/modules/now/components/Batch';
import { JobDocuments, JobGeneral, JobTimeline } from '@v2/pages/machines/modules/now/components/Job';
import {
  NCFileDocuments,
  NCFileEventsActive,
  NCFileEventsChange,
  NCFileEventsCycle,
  NCFileEventsNavigator,
  NCFileEventsSetup,
  NCFileEventsTrace,
  NCFileGeneral,
  NCFileLinks,
  NCFilePerformanceActive,
  NCFIlePerformanceNavigator,
  NCFilePerformancePaid,
  NCFilePerformanceProductive,
  NCFilePerformanceUtilization,
  NCFileVersions,
  NCFileTimeline,
} from '../modules/now/components/NC-file';
import { PartDocuments, PartGeneral, PartTimeline } from '@v2/pages/machines/modules/now/components/Part';
import { ToolsGeneral } from '@v2/pages/machines/modules/now/components/Tools';
import { PerformanceActive, PerformancePaid, PerformanceProductive, PerformanceUtilization } from '@v2/pages/machines/modules/performance/components';
import { BatchNavigator } from './BatchNavigator';
import { JobNavigator } from './JobNavigator';
import { NCFIleNavigator } from './NCFileNavigator';
import { PartNavigator } from './PartNavigator';
import { ToolNavigator } from './ToolNavigator';
import { Batches } from '@v2/pages/machines/modules/batches/components';
import { Scheduled } from '@v2/pages/machines/modules/scheduled/components';
import { Maintenance } from '@v2/pages/machines/modules/maintenance/components';
import { EventDetails } from '@v2/pages/machines/modules/events/components/details';
import { CombinedEvent } from '@v2/pages/machines/modules/events/components/combined';
import { PerformanceNavigation } from './PerformanceNavigation';
import { navigationLevels } from '@v2/pages/machines/common/constants';
import { Timeline } from '@v2/pages/machines/modules/timeline/components';
import { NcFileBatchEventType, NcFileBatchEventsLink } from '@v2/pages/common/enums';
import MachineDetailsSecret from '@components/machineDetails';
import { BatchLevelSubScreen } from '@v2/pages/batch/details/common/enums/batchDetails.enum';
import {
  BatchEventsCycle,
  BatchEventsActive,
  BatchEventsChange,
  BatchEventsSetup,
  BatchEventsTrace,
  BatchEventsNavigator,
} from '../modules/now/components/Batch/BatchEvents';
import { machineEventsMainMenuAvailable, timelineAvailable } from '@config/navigationRestrictions';
import { injectConditionalArrayItems, injectConditionalObject } from '@helpers';
import {
  MachineEventsActive,
  MachineEventsChange,
  MachineEventsCycle,
  MachineEventsSetup,
  MachineEventsTrace,
  MachinesEventsNavigator,
} from '../modules/events/components';

import { ToolLevelSubScreen } from '@v2/pages/tools/details/common/enums/toolsDetails.enum';
import { NCFileLevelSubScreen } from '@v2/pages/nc-file/details/common/enums/ncFileDetails.enum';
import { JobLevelSubScreen } from '@v2/pages/job/common/enums/jobDetails.enum';
import { PartLevelSubScreen } from '@v2/pages/part/details/common/enums/partDetails.enum';
import MachinesNowOverviewScreen from '@v2/pages/machines/modules/now/components/Overview/MachinesNowOverviewScreen';

export const MACHINES_MAIN_SCREEN = 'Machines';
export const MACHINES_DETAILS_SECRET_SCREEN = 'DetailsSecret';

export const machinesLinking = {
  path: 'machines',
  screens: {
    [`${MACHINES_MAIN_SCREEN}${MACHINES_DETAILS_SECRET_SCREEN}`]: 'detailsSecret',
    [`${MACHINES_MAIN_SCREEN}${MachinesScreen.PERFORMANCE}`]: {
      path: ContextLink.PERFORMANCE,
      screens: {
        [`${MACHINES_MAIN_SCREEN}${MachinesScreen.UTILIZATION}`]: MetricTypeLink.UTILIZATION,
        [`${MACHINES_MAIN_SCREEN}${MachinesScreen.ACTIVE}`]: MetricTypeLink.ACTIVE,
        [`${MACHINES_MAIN_SCREEN}${MachinesScreen.PRODUCTIVE}`]: MetricTypeLink.PRODUCTIVE,
        [`${MACHINES_MAIN_SCREEN}${MachinesScreen.PAID}`]: MetricTypeLink.PAID,
      },
    },
    // [`${MACHINES_MAIN_SCREEN}${MachinesScreen.LIVE}`]: {
    //   path: ContextLink.LIVE,
    //   screens: {
    //     [NowSubScreen.PART]: {
    //       path: NowSubScreenLink.PART,
    //       screens: createLevelSubScreenLinking(NowSubScreen.PART, {
    //         levels: filteredPartLevelSubScreen,
    //         links: filteredPartLevelSubScreenLink,
    //       }),
    //     },
    //     [NowSubScreen.JOB]: {
    //       path: NowSubScreenLink.JOB,
    //       screens: createLevelSubScreenLinking(NowSubScreen.JOB, {
    //         levels: filteredJobLevelSubScreen,
    //         links: filteredJobLevelSubScreenLink,
    //       }),
    //     },
    //     [NowSubScreen.BATCH]: {
    //       path: NowSubScreenLink.BATCH,
    //       screens: createLevelSubScreenLinking(NowSubScreen.BATCH, {
    //         levels: filteredBatchLevelSubScreen,
    //         links: filteredBatchLevelSubScreenLink,
    //         nestedScreens: {
    //           [BatchLevelSubScreen.TIMES]: {
    //             screenName: BatchLevelSubScreen.TIMES,
    //             items: NcFileBatchEventType,
    //             links: NcFileBatchEventsLink,
    //           },
    //         },
    //       }),
    //     },
    //     [NowSubScreen.NC_FILE]: {
    //       path: NowSubScreenLink.NC_FILE,
    //       screens: createLevelSubScreenLinking(NowSubScreen.NC_FILE, {
    //         levels: filteredNCFileLevelSubScreen,
    //         links: filteredNCFileLevelSubScreenLink,
    //         nestedScreens: {
    //           [NCFileLevelSubScreen.TIMES]: {
    //             screenName: NCFileLevelSubScreen.TIMES,
    //             items: NcFileBatchEventType,
    //             links: NcFileBatchEventsLink,
    //           },
    //         },
    //       }),
    //     },
    //     [NowSubScreen.TOOLS]: {
    //       path: NowSubScreenLink.TOOLS,
    //       screens: createLevelSubScreenLinking(NowSubScreen.TOOLS, {
    //         levels: ToolLevelSubScreen,
    //         links: ToolLevelSubScreenLink,
    //       }),
    //     },
    //   },
    // },
    [`${MACHINES_MAIN_SCREEN}${MachinesScreen.LIVE}`]: ContextLink.LIVE,
    ...injectConditionalObject(timelineAvailable, {
      [`${MACHINES_MAIN_SCREEN}${MachinesScreen.TIMELINE}`]: ContextLink.TIMELINE,
    }),
    ...injectConditionalObject(machineEventsMainMenuAvailable, {
      [`${MACHINES_MAIN_SCREEN}${MachinesScreen.EVENTS}`]: {
        path: ContextLink.EVENTS,
        screens: {
          [`${MACHINES_MAIN_SCREEN}${MachinesScreen.EVENTS}${NcFileBatchEventType.CYCLE}`]: NcFileBatchEventsLink.CYCLE,
          [`${MACHINES_MAIN_SCREEN}${MachinesScreen.EVENTS}${NcFileBatchEventType.ACTIVE}`]: NcFileBatchEventsLink.ACTIVE,
          [`${MACHINES_MAIN_SCREEN}${MachinesScreen.EVENTS}${NcFileBatchEventType.CHANGE}`]: NcFileBatchEventsLink.CHANGE,
          [`${MACHINES_MAIN_SCREEN}${MachinesScreen.EVENTS}${NcFileBatchEventType.SETUP}`]: NcFileBatchEventsLink.SETUP,
          [`${MACHINES_MAIN_SCREEN}${MachinesScreen.EVENTS}${NcFileBatchEventType.TRACE}`]: NcFileBatchEventsLink.TRACE,
        },
      },
    }),
    [`${MACHINES_MAIN_SCREEN}${MachinesScreen.EVENT_COMBINED}`]: EventTypeLink.COMBINED,
    [`${MACHINES_MAIN_SCREEN}${MachinesScreen.EVENT_DETAILS}`]: EventTypeLink.DETAILS,
    [`${MACHINES_MAIN_SCREEN}${MachinesScreen.HISTORY}`]: ContextLink.HISTORY,
    [`${MACHINES_MAIN_SCREEN}${MachinesScreen.SCHEDULED}`]: ContextLink.SCHEDULED,
    [`${MACHINES_MAIN_SCREEN}${MachinesScreen.MAINTENANCE}`]: ContextLink.MAINTENANCE,
  },
};

export const machinesComponentsConfig = [
  { name: `${MACHINES_MAIN_SCREEN}${MACHINES_DETAILS_SECRET_SCREEN}`, Component: MachineDetailsSecret },
  ...injectConditionalArrayItems(timelineAvailable, {
    name: `${MACHINES_MAIN_SCREEN}${MachinesScreen.TIMELINE}`,
    Component: Timeline,
  }),
  ...injectConditionalArrayItems(machineEventsMainMenuAvailable, {
    name: `${MACHINES_MAIN_SCREEN}${MachinesScreen.EVENTS}`,
    Component: MachinesEventsNavigator,
  }),
  {
    name: `${MACHINES_MAIN_SCREEN}${MachinesScreen.HISTORY}`,
    Component: Batches,
  },
  {
    name: `${MACHINES_MAIN_SCREEN}${MachinesScreen.LIVE}`,
    Component: MachinesNowOverviewScreen,
  },
  {
    name: `${MACHINES_MAIN_SCREEN}${MachinesScreen.SCHEDULED}`,
    Component: Scheduled,
  },
  {
    name: `${MACHINES_MAIN_SCREEN}${MachinesScreen.MAINTENANCE}`,
    Component: Maintenance,
  },
  {
    name: `${MACHINES_MAIN_SCREEN}${MachinesScreen.PERFORMANCE}`,
    Component: PerformanceNavigation,
  },
  // {
  //   name: `${MACHINES_MAIN_SCREEN}${MachinesScreen.EVENTS}`,
  //   Component: EventsDefaultComponent,
  // },
  {
    name: `${MACHINES_MAIN_SCREEN}${MachinesScreen.EVENT_DETAILS}`,
    Component: EventDetails,
  },
  {
    name: `${MACHINES_MAIN_SCREEN}${MachinesScreen.EVENT_COMBINED}`,
    Component: CombinedEvent,
  },
];

export const nowComponentsConfig = [
  {
    name: NowSubScreen.PART,
    Component: PartNavigator,
  },
  {
    name: NowSubScreen.JOB,
    Component: JobNavigator,
  },
  {
    name: NowSubScreen.BATCH,
    Component: BatchNavigator,
  },
  {
    name: NowSubScreen.NC_FILE,
    Component: NCFIleNavigator,
  },
  {
    name: NowSubScreen.TOOLS,
    Component: ToolNavigator,
  },
];

export const performanceComponentsConfig = [
  {
    name: `${MACHINES_MAIN_SCREEN}${MachinesScreen.UTILIZATION}`,
    Component: PerformanceUtilization,
  },
  {
    name: `${MACHINES_MAIN_SCREEN}${MachinesScreen.ACTIVE}`,
    Component: PerformanceActive,
  },
  {
    name: `${MACHINES_MAIN_SCREEN}${MachinesScreen.PRODUCTIVE}`,
    Component: PerformanceProductive,
  },
  {
    name: `${MACHINES_MAIN_SCREEN}${MachinesScreen.PAID}`,
    Component: PerformancePaid,
  },
];

export const nowJobConfig = [
  {
    name: `${NowSubScreen.JOB}${JobLevelSubScreen.GENERAL}`,
    Component: JobGeneral,
  },
  ...injectConditionalArrayItems(timelineAvailable, {
    name: `${NowSubScreen.JOB}${JobLevelSubScreen.TIMELINE}`,
    Component: JobTimeline,
  }),
  {
    name: `${NowSubScreen.JOB}${JobLevelSubScreen.DOCUMENTS}`,
    Component: JobDocuments,
  },
];

export const nowBatchConfig = [
  {
    name: `${NowSubScreen.BATCH}${BatchLevelSubScreen.GENERAL}`,
    Component: BatchGeneral,
  },
  ...injectConditionalArrayItems(timelineAvailable, {
    name: `${NowSubScreen.BATCH}${BatchLevelSubScreen.TIMELINE}`,
    Component: BatchTimelineScreen,
  }),
  {
    name: `${NowSubScreen.BATCH}${BatchLevelSubScreen.TIMES}`,
    Component: BatchEventsNavigator,
  },
  // {
  //   name: `${NowSubScreen.BATCH}${BatchLevelSubScreen.VERSIONS}`,
  //   Component: BatchVersions,
  // },
  {
    name: `${NowSubScreen.BATCH}${BatchLevelSubScreen.DOCUMENTS}`,
    Component: BatchDocuments,
  },
];

export const nowNCFileConfig = [
  {
    name: `${NowSubScreen.NC_FILE}${NCFileLevelSubScreen.GENERAL}`,
    Component: NCFileGeneral,
  },
  // Based on task SF-4963
  // ...injectConditionalArrayItems(timelineAvailable, {
  //   name: `${NowSubScreen.NC_FILE}${NCFileLevelSubScreen.TIMELINE}`,
  //   Component: NCFileTimeline,
  // }),
  
  // {
  //   name: `${NowSubScreen.NC_FILE}${NCFileLevelSubScreen.TIMES}`,
  //   Component: NCFileTimes,
  // },
  {
    name: `${NowSubScreen.NC_FILE}${NCFileLevelSubScreen.TIMES}`,
    Component: NCFileEventsNavigator,
  },
  {
    name: `${NowSubScreen.NC_FILE}${NCFileLevelSubScreen.PERFORMANCE}`,
    Component: NCFIlePerformanceNavigator,
  },
  {
    name: `${NowSubScreen.NC_FILE}${NCFileLevelSubScreen.VERSIONS}`,
    Component: NCFileVersions,
  },
  {
    name: `${NowSubScreen.NC_FILE}${NCFileLevelSubScreen.LINKS}`,
    Component: NCFileLinks,
  },
  {
    name: `${NowSubScreen.NC_FILE}${NCFileLevelSubScreen.DOCUMENTS}`,
    Component: NCFileDocuments,
  },
];

export const nowPartConfig = [
  {
    name: `${NowSubScreen.PART}${PartLevelSubScreen.GENERAL}`,
    Component: PartGeneral,
  },
  ...injectConditionalArrayItems(timelineAvailable, {
    name: `${NowSubScreen.PART}${PartLevelSubScreen.TIMELINE}`,
    Component: PartTimeline,
  }),
  {
    name: `${NowSubScreen.PART}${PartLevelSubScreen.DOCUMENTS}`,
    Component: PartDocuments,
  },
];

export const nowToolConfig = [
  {
    name: `${NowSubScreen.TOOLS}${ToolLevelSubScreen.GENERAL}`,
    Component: ToolsGeneral,
  },
];

export const nowNCFilePerformanceConfig = [
  {
    name: `${NowSubScreen.NC_FILE}${NCFileLevelSubScreen.PERFORMANCE}${navigationLevels.metricTypes.active}`,
    Component: NCFilePerformanceActive,
  },
  {
    name: `${NowSubScreen.NC_FILE}${NCFileLevelSubScreen.PERFORMANCE}${navigationLevels.metricTypes.productive}`,
    Component: NCFilePerformanceProductive,
  },
  {
    name: `${NowSubScreen.NC_FILE}${NCFileLevelSubScreen.PERFORMANCE}${navigationLevels.metricTypes.paid}`,
    Component: NCFilePerformancePaid,
  },
  {
    name: `${NowSubScreen.NC_FILE}${NCFileLevelSubScreen.PERFORMANCE}${navigationLevels.metricTypes.utilization}`,
    Component: NCFilePerformanceUtilization,
  },
];

export const nowBatchEventsConfig = [
  {
    name: `${NowSubScreen.BATCH}${BatchLevelSubScreen.TIMES}${NcFileBatchEventType.CYCLE}`,
    Component: BatchEventsCycle,
  },
  {
    name: `${NowSubScreen.BATCH}${BatchLevelSubScreen.TIMES}${NcFileBatchEventType.ACTIVE}`,
    Component: BatchEventsActive,
  },
  {
    name: `${NowSubScreen.BATCH}${BatchLevelSubScreen.TIMES}${NcFileBatchEventType.SETUP}`,
    Component: BatchEventsSetup,
  },
  {
    name: `${NowSubScreen.BATCH}${BatchLevelSubScreen.TIMES}${NcFileBatchEventType.CHANGE}`,
    Component: BatchEventsChange,
  },
  {
    name: `${NowSubScreen.BATCH}${BatchLevelSubScreen.TIMES}${NcFileBatchEventType.TRACE}`,
    Component: BatchEventsTrace,
  },
];

export const nowNCFileEventsConfig = [
  {
    name: `${NowSubScreen.NC_FILE}${NCFileLevelSubScreen.TIMES}${NcFileBatchEventType.CYCLE}`,
    Component: NCFileEventsCycle,
  },
  {
    name: `${NowSubScreen.NC_FILE}${NCFileLevelSubScreen.TIMES}${NcFileBatchEventType.ACTIVE}`,
    Component: NCFileEventsActive,
  },
  {
    name: `${NowSubScreen.NC_FILE}${NCFileLevelSubScreen.TIMES}${NcFileBatchEventType.SETUP}`,
    Component: NCFileEventsSetup,
  },
  {
    name: `${NowSubScreen.NC_FILE}${NCFileLevelSubScreen.TIMES}${NcFileBatchEventType.CHANGE}`,
    Component: NCFileEventsChange,
  },
  {
    name: `${NowSubScreen.NC_FILE}${NCFileLevelSubScreen.TIMES}${NcFileBatchEventType.TRACE}`,
    Component: NCFileEventsTrace,
  },
];

export const machinesEventsConfig = [
  {
    name: `${MACHINES_MAIN_SCREEN}${MachinesScreen.EVENTS}${NcFileBatchEventType.CYCLE}`,
    Component: MachineEventsCycle,
  },
  {
    name: `${MACHINES_MAIN_SCREEN}${MachinesScreen.EVENTS}${NcFileBatchEventType.ACTIVE}`,
    Component: MachineEventsActive,
  },
  {
    name: `${MACHINES_MAIN_SCREEN}${MachinesScreen.EVENTS}${NcFileBatchEventType.SETUP}`,
    Component: MachineEventsSetup,
  },
  {
    name: `${MACHINES_MAIN_SCREEN}${MachinesScreen.EVENTS}${NcFileBatchEventType.CHANGE}`,
    Component: MachineEventsChange,
  },
  {
    name: `${MACHINES_MAIN_SCREEN}${MachinesScreen.EVENTS}${NcFileBatchEventType.TRACE}`,
    Component: MachineEventsTrace,
  },
];
